import React, { useRef } from 'react';
import { Container, Card, Alert } from 'react-bootstrap';
import { Button } from '@devesharp/react/web';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Style from './EstablishmentZoopPage.style';
import { LoadingPage } from '~/components';
import { CNPJAndCPFMask } from '~/services';
import { useEstablishmentZoopPage } from '~/pages/EstablishmentZoop/EstablishmentZoopPage.controller';
import { Input } from '~/components/Customs/Input';
import { Select } from '~/components/Customs/Select';
import { SelectAutoComplete } from '~/components/Customs/SelectAutoComplete';

export const EstablishmentZoopPage: React.FunctionComponent<any> = () => {
   const formRef = useRef<FormHandles>(null);
   const ctrl = useEstablishmentZoopPage(formRef);

   if (ctrl.loadingCompany) {
      return (
         <Style>
            <LoadingPage />
         </Style>
      );
   }

   return (
      <Style>
         <div className="title-page">
            <div className="container">
               <div className="p-3">
                  <div className="row">
                     <div className="col">
                        <h3 className="m-0 mb-1">
                           {ctrl.hasZoopSeller ? 'Gerenciar seller Zoop' : 'Cadastrar seller na Zoop'}
                        </h3>
                        <p className="text-muted mb-0">
                           {ctrl.hasZoopSeller
                              ? 'Envie ou substitua os documentos KYC do sócio.'
                              : 'Complete os dados bancários, acesso e documentos KYC do sócio.'}
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         {ctrl.saving && <LoadingPage />}

         <div className="container-form m-auto">
            {ctrl.company ? (
               <Card className="mb-3 p-3">
                  <strong>{ctrl.company.name ?? ctrl.company.business_name}</strong>
                  <div className="text-muted">
                     {ctrl.company.type === 'business' ? 'Pessoa jurídica' : 'Pessoa física'}
                     {ctrl.company.document || ctrl.company.ein || ctrl.company.taxpayer_id
                        ? ` · ${CNPJAndCPFMask(ctrl.company.document ?? ctrl.company.ein ?? ctrl.company.taxpayer_id)}`
                        : ''}
                  </div>
               </Card>
            ) : null}

            {ctrl.hasZoopSeller ? (
               <Alert variant="info" className="mb-3">
                  Este estabelecimento já possui seller na Zoop. Por enquanto, aqui você pode apenas enviar ou
                  substituir documentos KYC do sócio.
               </Alert>
            ) : (
               <Alert variant="warning" className="mb-3">
                  Para concluir o cadastro, envie a <b>selfie</b> e o <b>RG (frente e verso)</b> do sócio. Tamanho
                  máximo: 5MB por arquivo.
               </Alert>
            )}

            <Form ref={formRef} onSubmit={ctrl.onSubmit} initialData={{ bank_type: 'checking' }}>
               <Card className="p-n">
                  {!ctrl.hasZoopSeller ? (
                     <>
                        <div className="form-padding">
                           <div className="form-title">Dados Zoop</div>
                           <br />
                           <div className="row field-box">
                              <div className="col-md-12">
                                 <SelectAutoComplete
                                    name="mcc"
                                    title="Categoria do negócio (MCC)"
                                    options={ctrl.formInfoData.MCC}
                                 />
                              </div>
                           </div>
                           <div className="row field-box">
                              <div className="col-md-12">
                                 <Input name="statement_descriptor" title="Nome na fatura" />
                              </div>
                           </div>
                        </div>

                        <hr />

                        <div className="form-padding ">
                           <div className="form-title">Conta bancária</div>
                           <br />
                           <div className="pb-3">
                              A conta bancária precisa ser do mesmo titular do estabelecimento.
                           </div>
                           <div className="row field-box">
                              <div className="col-md-12">
                                 <Select
                                    name="bank_type"
                                    title="Tipo de Conta"
                                    options={ctrl.formInfoData.accountType}
                                 />
                              </div>
                           </div>
                           <div className="row field-box">
                              <div className="col-md-12">
                                 <SelectAutoComplete
                                    name="bank_code"
                                    title="Banco"
                                    options={ctrl.formInfoData.bankCodes}
                                 />
                              </div>
                           </div>
                           <div className="row field-box">
                              <div className="col-md-4">
                                 <Input name="bank_routing_number" title="Agência da Conta" />
                              </div>
                              <div className="col-md-3">
                                 <Input name="bank_account_number" title="Conta Bancária" />
                              </div>
                           </div>
                        </div>

                        <hr />

                        <div className="form-padding ">
                           <div className="form-title">Acesso ao Painel</div>
                           <div className="row field-box">
                              <div className="col-md-6">
                                 <Input name="user_login" title="Login" />
                              </div>
                              <div className="col-md-6">
                                 <Input name="user_password" title="Senha de acesso" />
                              </div>
                           </div>
                        </div>

                        <hr />
                     </>
                  ) : null}

                  <div className="form-padding">
                     <div className="form-title">Documentos KYC do sócio</div>
                     <p className="text-muted">
                        {ctrl.hasZoopSeller
                           ? 'Selecione os documentos que deseja enviar ou substituir. Formatos: PNG, JPEG, PDF (máx. 5MB).'
                           : 'Selfie e RG (frente e verso) são obrigatórios na criação. Formatos: PNG, JPEG, PDF (máx. 5MB).'}
                     </p>
                     <div className="row field-box">
                        {ctrl.documentFields.map((field: any) => {
                           const hasPending = Boolean(field.pending);
                           const hasExisting = Boolean(field.existing);
                           const className = [
                              'document-upload',
                              'mb-3',
                              'col-md-12',
                              hasPending || hasExisting ? 'has-file' : '',
                              field.error ? 'has-error' : '',
                           ]
                              .filter(Boolean)
                              .join(' ');

                           return (
                              <div className={className} key={field.type}>
                                 <span className="document-upload__label">
                                    {field.label}
                                    {!ctrl.hasZoopSeller || !hasExisting ? ' *' : ''}
                                 </span>
                                 <div className="document-upload__hint">
                                    Tipo Zoop: {field.type}
                                 </div>
                                 {hasExisting && !hasPending ? (
                                    <div className="document-upload__status">
                                       Enviado: {field.existing.original_name ?? field.type}
                                    </div>
                                 ) : null}
                                 {hasPending ? (
                                    <div className="document-upload__status">
                                       Selecionado: {field.pending.name}
                                    </div>
                                 ) : null}
                                 <input
                                    type="file"
                                    accept="image/png,image/jpeg,image/jpg,image/bmp,image/webp,image/heic,image/heif,application/pdf"
                                    onChange={(event) =>
                                       ctrl.onDocumentChange(field.type, event.target.files?.[0] ?? null)
                                    }
                                 />
                                 {field.error ? (
                                    <div className="document-upload__error">{field.error}</div>
                                 ) : null}
                              </div>
                           );
                        })}
                     </div>
                  </div>
               </Card>

               <div className="text-right pt-2">
                  <Button size="lg" type="submit">
                     <b>
                        {ctrl.hasZoopSeller ? 'Enviar documentos' : 'Criar seller e enviar documentos'}
                     </b>
                  </Button>
               </div>
               <br />
               <br />
            </Form>
         </div>
         <Container />
      </Style>
   );
};
